import React, { Fragment, useRef } from "react";
import PropTypes from "prop-types";

import Form, { Select } from "../Components/SmartForm";

const Pagination = ({
    currentPage,
    maxPageNumber,
    offset,
    pageSize,
    pageSizeOptions
}) => {
    const form = useRef();

    const pageNumberButtons = () => {
        let paginationButtons = [];
        let pagination = {
            currentPage: parseInt(currentPage),
            offset: offset,
            startAt: parseInt(currentPage) - offset,
            endAt: parseInt(currentPage) + offset,
            maxPageNumber: maxPageNumber
        };

        if(pagination.startAt < 1){
            const offset = 1 - pagination.startAt;

            pagination.startAt = 1;
            pagination.endAt += offset;
        }

        if(pagination.endAt > maxPageNumber){
            const offset = (pagination.endAt - maxPageNumber);

            pagination.endAt = maxPageNumber;
            pagination.startAt -= offset;
            if (pagination.startAt <= 0) {
                pagination.startAt = 1;
            }
        }

        if(pagination.currentPage > 1){
            paginationButtons.push(
                <a
                    href={`?currentPage=${pagination.currentPage - 1}&pageSize=${pageSize}`}
                    className="page-button"
                >
                    &lt;
                </a>
            );
        }

        for(let i = pagination.startAt; i <= pagination.endAt; i++){
            paginationButtons.push(
                <a className={`page-button ${pagination.currentPage === i ? "active" : ""}`} href={`?currentPage=${i}&pageSize=${pageSize}`}>{i}</a>
            );
        }

        if(pagination.currentPage < pagination.maxPageNumber){
            paginationButtons.push(
                <a
                    href={`?currentPage=${pagination.currentPage + 1}&pageSize=${pageSize}`}
                    className="page-button"
                >
                    &gt;
                </a>
            );
        }

        return paginationButtons;
    };

    return (
        <Fragment>
            <div className="paging-icon">
                <div className="icon grid active">
                    <a>
                        <i className="fa fa-table" aria-hidden="true"></i>
                    </a>
                </div>
                <div className="icon list">
                    <a>
                        <i className="fa fa-list-ul" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <section id="pages">
                {pageNumberButtons()}
            </section>
            {(pageSize && pageSizeOptions.length > 1) && <Form
                id="page-size"
                className="px-0 show-per-page"
                contextRef={form}
                defaults={{ pageSize: pageSizeOptions.find(size => size == pageSize) }}
            >
                <div className="d-flex align-items-center">
                    <div>Show</div>
                    <PageSizeSelect pageSizeOptions={pageSizeOptions} />
                    <div>Per Page</div>
                </div>
            </Form>}
        </Fragment>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    maxPageNumber: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageSizeOptions: PropTypes.array.isRequired
};

const PageSizeSelect = ({ pageSizeOptions }) => {
    const handleChange = event => {
        const newPageSize = event.target.value;
        let params = (new URL(document.location)).searchParams;

        params.set("pageSize", newPageSize);

        location.search = params.toString();
    };

    return (
        <Select
            name="pageSize"
            label="Items Per Page"
            className="form-control mx-2"
            onChange={handleChange}
            style={{
                width: "50px",
                height: "25px"
            }}
        >
            {pageSizeOptions.map(value => (
                <option key={value} value={value}>{value}</option>
            ))}
        </Select>
    );
};

PageSizeSelect.propTypes = {
    pageSizeOptions: PropTypes.array.isRequired
};

export default Pagination;